var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgVeganSymbol = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "23px",
    width: "23px",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Vegan product") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6 7l-2.695 7.7h-1.21L7 7h1.21l2.09 6.006L12.39 7z",
    fill: "#283333",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    stroke: "#283333"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVeganSymbol);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,ICA8c3ZnIGhlaWdodD0iMjNweCIgd2lkdGg9IjIzcHgiPgogICAgPHRpdGxlPlZlZ2FuIHByb2R1Y3Q8L3RpdGxlPgogICAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxIDEpIj4KICAgICAgPHBhdGgKICAgICAgICBkPSJNMTMuNiA3bC0yLjY5NSA3LjdoLTEuMjFMNyA3aDEuMjFsMi4wOSA2LjAwNkwxMi4zOSA3eiIKICAgICAgICBmaWxsPSIjMjgzMzMzIgogICAgICAgIGZpbGwtcnVsZT0ibm9uemVybyIKICAgICAgLz4KICAgICAgPGNpcmNsZSBjeD0iMTAuNSIgY3k9IjEwLjUiIHI9IjEwLjUiIHN0cm9rZT0iIzI4MzMzMyIgLz4KICAgIDwvZz4KICA8L3N2Zz4=";